import Auth from "../pages/Auth";
import withPublicAccess from "../hocs/withPublicAccess";
import withPrivateAccess from "../hocs/withPrivateAccess";
import ForgotPasswordForm from "../views/ForgotPasswordFormView";
import LoginFormView from "../views/LoginFormView/LoginFormView";
import LoginOtpFormView from "../views/LoginOtpFormView/LoginOtpFormView";
import ForgotPasswordResetFormView from "../views/ForgotPasswordResetFormView";
import Home from "../pages/Home";
import MyAccountView from "../views/MyAccountView";
import AddProductCategoryView from "../views/AddProductCategoryView";
import ProductCategoryView from "../views/ProductCategoryView";
import AddQuestionnaireView from "../views/AddQuestionnaireView/AddQuestionnaireView";
import UserListingView from "../views/UseListingView";
import AddUserManagementView from "../views/AddUserManagementView/AddUserManagementView";
import PlanAuditView from "../views/PlanAuditView";
import QuestionnaireListingView from "../views/QuestionnaireListingView";
import AuditListingView from "../views/AuditListingView";
import SeeAllNotificationsView from "../views/SeeAllNotificationsView";
import RemoteAuditContainer from "../containers/RemoteAuditContainer";
import DashboardView from "../views/DasboardView/DasboardView";
import ErrorPage from "../containers/ErrorPage";
import { userRole } from "../constants";
import ProtectedRoute from "../hocs/ProtectedRoute";
import AccessDenied from "../containers/AccessDenied";

const LoginWithPublicAccess = withPublicAccess(Auth);
const HomeWithPrivateAccess = withPrivateAccess(Home);

const config = [
  {
    pagePath: "/dnsd",
    element: <Home />,
    views: [
      {
        viewPath: "audit/self/:auditId/:token",
        element: <AddQuestionnaireView />, // view
      },
      {
        viewPath: "audit/remote/:auditId/:token",
        element: <RemoteAuditContainer />,
      },
    ],
  },
  {
    pagePath: "/login",
    element: <LoginWithPublicAccess />, // Page
    views: [
      // array of views under Page route
      {
        viewPath: "",
        element: <LoginFormView />, // view
      },
      {
        viewPath: "otp",
        element: <LoginOtpFormView />, // view
      },
      {
        viewPath: "forgot-password",
        element: <ForgotPasswordForm />, // view
      },
      {
        viewPath: "forgot-password/:passwordResetKey",
        element: <ForgotPasswordResetFormView />, // view
      },
    ],
  },
  {
    pagePath: "/",
    element: <HomeWithPrivateAccess />, // Page
    views: [
      // array of views under Page route
      {
        viewPath: "",
        element: (
          <ProtectedRoute
            element={<DashboardView />}
            allowedRoles={[userRole.ADMIN, userRole.CA, userRole.TM]}
          />
        ), //view
      },
      {
        viewPath: "product-category",
        element: (
          <ProtectedRoute
            element={<ProductCategoryView />}
            allowedRoles={[userRole.ADMIN, userRole.CA]}
          />
        ),
      },
      {
        viewPath: "add-product-category",
        element: (
          <ProtectedRoute
            element={<AddProductCategoryView />}
            allowedRoles={[userRole.ADMIN]}
          />
        ),
      },
      {
        viewPath: "edit-product-category/:id",
        element: (
          <ProtectedRoute
            element={<AddProductCategoryView />}
            allowedRoles={[userRole.ADMIN]}
          />
        ),
      },
      {
        viewPath: "view-product-category/:id",
        element: (
          <ProtectedRoute
            element={<AddProductCategoryView />}
            allowedRoles={[userRole.ADMIN, userRole.CA]}
          />
        ),
      },
      {
        viewPath: "questionnaire",
        element: (
          <ProtectedRoute
            element={<QuestionnaireListingView />}
            allowedRoles={[userRole.ADMIN, userRole.CA]}
          />
        ), // view
      },
      {
        viewPath: "add-questionnaire",
        element: (
          <ProtectedRoute
            element={<AddQuestionnaireView />}
            allowedRoles={[userRole.ADMIN]}
          />
        ), // view
      },
      {
        viewPath: "edit-questionnaire/:id",
        element: (
          <ProtectedRoute
            element={<AddQuestionnaireView />}
            allowedRoles={[userRole.ADMIN, userRole.CA]}
          />
        ), // view
      },
      {
        viewPath: "view-questionnaire/:id",
        element: (
          <ProtectedRoute
            element={<AddQuestionnaireView />}
            allowedRoles={[userRole.ADMIN, userRole.CA]}
          />
        ), // view
      },
      {
        viewPath: "users",
        element: (
          <ProtectedRoute
            element={<UserListingView />}
            allowedRoles={[userRole.ADMIN, userRole.CA]}
          />
        ), // view
      },
      {
        viewPath: "my-account",
        element: <MyAccountView />, // view
      },
      {
        viewPath: "add-user",
        element: (
          <ProtectedRoute
            element={<AddUserManagementView />}
            allowedRoles={[userRole.ADMIN, userRole.CA]}
          />
        ), // view
      },
      {
        viewPath: "view-user-details/:id",
        element: (
          <ProtectedRoute
            element={<AddUserManagementView />}
            allowedRoles={[userRole.ADMIN, userRole.CA]}
          />
        ), // view
      },
      {
        viewPath: "edit-user/:id",
        element: (
          <ProtectedRoute
            element={<AddUserManagementView />}
            allowedRoles={[userRole.ADMIN, userRole.CA]}
          />
        ), // view
      },
      {
        viewPath: "notifications",
        element: <SeeAllNotificationsView />, // view
      },
      {
        viewPath: "plan-audit",
        element: (
          <ProtectedRoute
            element={<PlanAuditView />}
            allowedRoles={[userRole.CA]}
          />
        ), // view
      },
      {
        viewPath: "audit-listing",
        element: (
          <ProtectedRoute
            element={<AuditListingView />}
            allowedRoles={[userRole.CA, userRole.TM, userRole.ADMIN]}
          />
        ), // view
      },
      {
        viewPath: "*",
        element: <ErrorPage />,
      },
      {
        viewPath: "audit/:id/:auditMedium",
        element: (
          <ProtectedRoute
            element={<AddQuestionnaireView />}
            allowedRoles={[userRole.TM]}
          />
        ), // view
      },
      {
        viewPath: "edit-audit/:id/:auditMedium",
        element: (
          <ProtectedRoute
            element={<AddQuestionnaireView />}
            allowedRoles={[userRole.TM]}
          />
        ), // view
      },
      {
        viewPath: "audit-preview/:id/:auditMedium",
        element: (
          <ProtectedRoute
            element={<AddQuestionnaireView />}
            allowedRoles={[userRole.CA, userRole.TM, userRole.ADMIN]}
          />
        ), // view
      },
      {
        viewPath: "audit/remote/:auditId",
        element: (
          <ProtectedRoute
            element={<RemoteAuditContainer />}
            allowedRoles={[userRole.CA, userRole.TM, userRole.ADMIN]}
          />
        ),
      },
      {
        viewPath: "/access-denied",
        element: <AccessDenied />,
      },
    ],
  },
];

export default config;
